import { render } from "./ProductCustomization.vue?vue&type=template&id=b0ba12f6&scoped=true&ts=true"
import script from "./ProductCustomization.vue?vue&type=script&lang=ts"
export * from "./ProductCustomization.vue?vue&type=script&lang=ts"

import "./ProductCustomization.vue?vue&type=style&index=0&id=b0ba12f6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ba12f6"]])

export default __exports__